import { TransactionsContextType } from "@zenith/context/global-context/types";
import { memo } from "react";
import CopyToClipboard from "@zenith/components/ui/CopyToClipboard/CopyToClipboard";
import { shouldShow, truncateText } from "@zenith/utils/TransactionDisplayHelpers";

export interface RefundTransactionDetailsProps {
  transaction: TransactionsContextType;
}

const RefundTransactionDetails = memo(function RefundTransactionDetails(
  props: RefundTransactionDetailsProps
) {
  const { transaction } = props;

  return (
    <>
      {shouldShow(transaction?.beneficiaryName) && (
        <div className="mb-2 flex justify-between">
          <p className="text-neutral-600">Payer's Name</p>
          <p className="font-medium text-neutral-900">
            {transaction?.beneficiaryName}
          </p>
        </div>
      )}

      {shouldShow(transaction?.bankName) && (
        <div className="mb-2 flex justify-between">
          <p className="text-neutral-600">Payer's Bank</p>
          <p className="font-medium text-neutral-900">
            {transaction?.bankName}
          </p>
        </div>
      )}

      {/* {shouldShow(transaction?.beneficiaryAccountNumber) && (
        <div className="mb-2 flex justify-between">
          <p className="text-neutral-600">Payer's Account</p>
          <CopyToClipboard text={transaction?.beneficiaryAccountNumber} />
        </div>
      )} */}

      {shouldShow(transaction?.refundReason) && (
        <div className="mb-2 flex justify-between">
          <p className="text-neutral-600">Additional Information</p>
          <p className="font-medium text-neutral-900">{transaction?.refundReason}</p>
        </div>
      )}

      {shouldShow(transaction?.sessionId) && (
        <div className="mb-2 flex justify-between">
          <p className="text-neutral-600">Session ID</p>
          <CopyToClipboard text={transaction?.sessionId} />
        </div>
      )}

      {shouldShow(transaction?.refundedTransactionId) && (
        <div className="mb-2 flex justify-between">
          <p className="text-neutral-600">Original Transaction ID</p>
          <CopyToClipboard text={transaction?.refundedTransactionId} />
        </div>
      )}

      {shouldShow(transaction?.description) && (
        <div className="mb-2 flex justify-between">
          <p className="text-neutral-600">Description</p>
          <div className="w-3/5 text-right">
            <p className="font-medium text-neutral-900 break-words">
              {truncateText(transaction?.description)}
            </p>
          </div>
        </div>
      )}
    </>
  );
});

export default RefundTransactionDetails;